import type { PartialMessageTextAndUrlDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type UserRestrictionsProps = {
  isAllowed: boolean;
  messageCode: string;
  title: string;
  partialMessages: Array<PartialMessageTextAndUrlDto>;
  ctaText: string;
  ctaUrl: string;
};

const UserRestrictions = ({
  isAllowed = true,
  messageCode = '',
  title = '',
  partialMessages = [],
  ctaText = '',
  ctaUrl = '',
}: Partial<UserRestrictionsProps> = {}) => {
  return {
    isAllowed,
    messageCode,
    title,
    partialMessages: partialMessages.map((p) => p),
    ctaText,
    ctaUrl,
  };
};

export { UserRestrictions, UserRestrictionsProps };
